import api from "../../api";
import { getEventIndexById } from "./utils";

// const __Y = moment().format("YYYY");
// const __M = moment().format("MM");

function formatEvents(events) {
  let newEvents = [];
  events.forEach((event) => {
    newEvents.push({
      // FullCalendar Properties
      id: event.Id,
      title: event.Title,
      start: event.EndDate, // Setting the start = EndDate causes the calendar to only show the EndDate of every event
      end: event.EndDate,
      allDay: event.AllDay,
      color: formatEventColor(event), //event.Color
      paid: event.Paid,
      amount: event.Amount2,
      // Extra properties
      isTask: false,
      agendaType: event.AgendaType,
      createdBy: event.CreatedBy,
      description: event.Description,
      endDate: event.EndDate, // Extra property for EndDate to display in forms because "end" appears as null
      startDate: event.StarDate, // Extra property for StartDate to display in forms
      TimeEstimated: 2, //event.TimeEstimated,
      IsFixed: event.IsFixed,
      MinuteHour: "m",
      invoiceType: event.invoiceType
    });
  });
  return newEvents;
}

function formatTasks(tasks) {
  let newEvents = [];
  tasks.forEach((task) => {
    newEvents.push({
      // FullCalendar properties
      title: `[${task.Id}] ${task.Name}`,
      start: task.LimiteDate, // Setting the start = EndDate causes the calendar to only show the EndDate of every event
      end: task.LimiteDate,
      allDay: task.AllDay,
      color: formatTaskColor(task),
      paid: task.Paid,
      amount: task.Amount,

      // Extra properties
      isTask: true,
      id: task.Id,
      description: task.Description,
      objectiveId: task.ObjetiveID,
      responsableId: task.ResponsableId,
      percentage: task.Percentage,
      startDate: task.InitialDate, // Extra property for StartDate to display in forms
      endDate: task.LimiteDate, // Extra property for EndDate to display in forms because "end" shows as null
      originalTitle: task.Name
    });
  });
  return newEvents;
}

function formatEventColor(event) {
  // Return pink if event is an appointment
  return event.Color;
  // return "#368939";
  // if (event.AgendaType == 1) {
  //   return "#db1492";
  // }

  // // Return orange if event is normal ("eventType")
  // return "#ffbd24";
}

function formatTaskColor(task) {
  // Return green if task is completed
  if (task.Percentage > 99) {
    return "#66ff2e";
  }

  // Return red if task is late
  if (task.LimiteDate) {
    const todayDate = new Date();
    const limitDate = new Date(task.LimiteDate);
    if (todayDate > limitDate) {
      return "#ff352e";
    }
  }

  // Return black if task is on time
  return "#42413e";
}

const state = {
  // events: [
  //   { title: "All Day Event", start: __Y + "-" + __M + "-01" },
  //   {
  //     title: "Long Event",
  //     start: __Y + "-" + __M + "-07",
  //     end: __Y + "-" + __M + "-10"
  //   },
  //   {
  //     id: 999,
  //     title: "Repeating Event",
  //     start: __Y + "-" + __M + "-09T16:00:00"
  //   },
  //   {
  //     id: 999,
  //     title: "Repeating Event",
  //     start: __Y + "-" + __M + "-16T16:00:00"
  //   },
  //   {
  //     title: "Conference",
  //     start: __Y + "-" + __M + "-11",
  //     end: __Y + "-" + __M + "-13"
  //   },
  //   {
  //     title: "Meeting",
  //     start: __Y + "-" + __M + "-12T10:30:00",
  //     end: __Y + "-" + __M + "-12T12:30:00"
  //   },
  //   { title: "Lunch", start: __Y + "-" + __M + "-12T12:00:00" },
  //   { title: "Meeting", start: __Y + "-" + __M + "-12T14:30:00" },
  //   { title: "Happy Hour", start: __Y + "-" + __M + "-12T17:30:00" },
  //   { title: "Dinner", start: __Y + "-" + __M + "-12T20:00:00" },
  //   { title: "Birthday Party", start: __Y + "-" + __M + "-13T07:00:00" },
  //   {
  //     title: "Click for Google",
  //     url: "http://google.com/",
  //     start: __Y + "-" + __M + "-28"
  //   }
  // ],
  events: [],
  calendarsForUser: [],
  calendarFPsInfo: [],
  weekendsVisible: true,
  eventsAreLoading: true,
  tasksAreLoading: true,
  calendarsAreLoading: true
};

const getters = {
  events: (state) => state.events,
  calendarsForUser: (state) => state.calendarsForUser,
  weekendsVisible: (state) => state.weekendsVisible,
  eventsAreLoading: (state) => state.eventsAreLoading,
  tasksAreLoading: (state) => state.tasksAreLoading,
  getCalendarFPsInfo: (state) => state.calendarFPsInfo
};

const actions = {
  getAllCalendarsForEmployee: ({ commit }, employeeID) => {
    // commit("toggle_events_are_loading", true);
    return new Promise((resolve, reject) => {
      api
        .get("/api/CalendarioFinanza/GetCalendariosByEmployeeID", {
          params: {
            employeeID: employeeID
          }
        })
        .then((resp) => {
          commit("getAllCalendarsForEmployee", resp.data);
          // commit("toggle_events_are_loading", false);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
          // commit("toggle_events_are_loading", false);
        });
    });
  },
  GetPersonalCalendario: ({ commit }, params) => {
    commit("toggle_events_are_loading", true);

    return new Promise((resolve, reject) => {
      api
        .get("/api/CalendarioFinanza/GetPersonalCalendario", {
          params: {
            employeeID: params.employeeID,
            invoiceType: params.invoiceType
          }
        })
        .then((resp) => {
          commit("toggle_events_are_loading", false);
          resolve(resp);
          commit("setCalendarFPsInfo", resp);
        })
        .catch((err) => {
          reject(err);
          commit("toggle_events_are_loading", false);
        });
    });
  },

  GetCalendario: ({ commit }, params) => {
    commit("toggle_events_are_loading", true);

    return new Promise((resolve, reject) => {
      api
        .get("/api/CalendarioFinanza/GetCalendarioByID", {
          params: {
            calendarioID: params.calendarioID,
            invoiceType: params.invoiceType
          }
        })
        .then((resp) => {
          const events = formatEvents(resp.data.AgendaFinances);
          commit("init", events);

          commit("toggle_events_are_loading", false);
          resolve(resp);
          commit("setCalendarFPsInfo", resp.data);
        })
        .catch((err) => {
          reject(err);
          commit("toggle_events_are_loading", false);
        });
    });
  },
  CreateCalendario: ({ commit }, payload) => {
    commit("toggle_events_are_loading", true);
    return new Promise((resolve, reject) => {
      api
        .post("/api/CalendarioFinanza/CreateCalendario", {
          EmployeeID: payload.employeeID,
          CalendarTitle: payload.calendarioTitle
        })
        .then((resp) => {
          commit("toggle_events_are_loading", false);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
          commit("toggle_events_are_loading", false);
        });
    });
  },
  DeleteCalendario: ({ commit }, payload) => {
    commit("toggle_events_are_loading", true);
    return new Promise((resolve, reject) => {
      api
        .delete("/api/CalendarioFinanza/DeleteCalendar", {
          data: {
            CalendarID: payload.CalendarID,
            EmployeeID: payload.EmployeeID
          }
        })
        .then(({ data }) => {
          commit("toggle_events_are_loading", false);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
          commit("toggle_events_are_loading", false);
          this.$message.error("Error al eliminar calendario");
        });
    });
  },
  initTasks: ({ commit }, employeeId) => {
    commit("toggle_tasks_are_loading", true);

    return new Promise((resolve, reject) => {
      api
        .get("/api/CMI/Task/GetbyTaskResponsableOrDeparment", {
          params: { Userid: employeeId }
        }) // Get tasks with EmployeeId
        .then((resp) => {
          const tasks = formatTasks(resp.data); // Converts task objects into a format that FullCalendar understands

          commit("addTasksToEvents", tasks);
          commit("toggle_tasks_are_loading", false);
          resolve(resp);
        })
        .catch((err) => {
          commit("toggle_tasks_are_loading", false);
          reject(err);
        });
    });
  },
  create: ({ commit }, event) => {
    return new Promise((resolve, reject) => {
      api
        .post("/api/CalendarFinances/add", event)
        .then((resp) => {
          commit("create", event);

          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  update: (_, event) => {
    return new Promise((resolve, reject) => {
      api
        .put("/api/CalendarFinances/edit", event)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  delete: (_, event) => {
    return new Promise((resolve, reject) => {
      api
        .delete("/api/CalendarFinances/delete", {
          data: event
        })
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updateTaskInApi: (_, task) => {
    return new Promise((resolve, reject) => {
      api
        .post("/api/CMI/Task/Edit", task)
        .then((resp) => {
          // commit("update", event);
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
};

const mutations = {
  init: (state, data) => {
    state.events = data;
  },
  addTasksToEvents: (state, data) => {
    data.forEach((task) => {
      state.events.push(task);
    });
  },
  create: (state, event) => {
    // Curerntly not being used, instead another GET call is being made to retrieve list of Events
    state.events.push(event);
  },
  update: (state, updatedEvent) => {
    // Curerntly not being used, instead another GET call is being made to retrieve list of Events
    const index = getEventIndexById(state, updatedEvent.ID);

    if (index === -1) {
      return console.warn(`Unable to update event (id ${updatedEvent.ID})`);
    }

    return state.events.splice(index, 1, {
      ...state.events[index],
      title: updatedEvent.title,
      start: updatedEvent.start,
      end: updatedEvent.end,
      date: updatedEvent.date
    });
  },
  getAllCalendarsForEmployee: (state, data) => {
    state.calendarsForUser = data;
  },
  setCalendarFPsInfo: (state, data) => {
    state.calendarFPsInfo = data;
  },
  set_weekends_visible: (state, enabled) => {
    state.weekendsVisible = enabled;
  },
  toggle_events_are_loading: (state, boolean) => {
    state.eventsAreLoading = boolean;
  },
  toggle_tasks_are_loading: (state, boolean) => {
    state.tasksAreLoading = boolean;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
